<template>
<div class="page-content">
  <nav class="page-breadcrumb" id="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ breadcrumbA }}</li>
      <li class="breadcrumb-item active" aria-current="page">
        {{ breadcrumbB }}
      </li>
    </ol>
  </nav>

  <div class="row">
    <div class="col-md-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <h6 class="card-title">Ajustes aprobados pendientes de resolución</h6>
          <p class="card-description">
            <span style="margin-left:5px;margin-top:5px;" class="badge badge-warning">En espera</span>
            <span style="margin-left:5px;margin-top:5px;" class="badge badge-success">Resuelto</span>
            <span style="margin-left:5px;margin-top:5px;" class="badge badge-info">Auditado</span>
          </p>
          <hr />
        </div>
      </div>
    </div>
  </div>

  <lista-carga v-if="load"></lista-carga>

  <div class="row" v-else>
    <div class="col-md-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <div class="row mb-3">
            <div class="col">
              <label class="mr-sm-2">Desde</label>
              <input type="date" class="form-control mb-2 mr-sm-2" id="desde" />
            </div>
            <div class="col">
              <label class="mr-sm-2">Hasta</label>
              <input type="date" class="form-control mb-2 mr-sm-2" id="hasta" />
            </div>
            <div class="col">
              <label class="mr-sm-2 w-100">&nbsp;</label>
              <button class="btn btn-md btn-success w-100" id="buscar">Consultar Ajustes</button>
            </div>
          </div>

          <div class="table-responsive">
            <table
              id="ajustes_resolucion"
              class="table table-theme table-row v-middle"
              data-plugin="dataTable"
            >
              <colgroup>
                <col style="width: 95px" />
                <col style="width: 95px" />
                <col style="width: 145px" />
                <col style="width: 150px" />
                <col style="width: 115px" />
                <col style="width: 150px" />
                <col style="width: 85px" />
                <col style="width: 190px" />
                <col style="width: 150px" />
                <col style="width: 90px" />
                <col style="width: 170px" />
                <col style="width: 145px" />
                <col style="width: 145px" />
                <col style="width: 145px" />
              </colgroup>

              <thead>
                <tr>
                  <th><span class="text-muted">Estado</span></th>
                  <th><span class="text-muted">ID ajuste</span></th>
                  <th><span class="text-muted">Fecha carga</span></th>
                  <th><span class="text-muted">Regional</span></th>
                  <th><span class="text-muted">DNI Regional</span></th>
                  <th><span class="text-muted">Operación</span></th>
                  <th><span class="text-muted">Legajo</span></th>
                  <th><span class="text-muted">Empleado</span></th>
                  <th><span class="text-muted">Concepto</span></th>
                  <th><span class="text-muted">Cantidad</span></th>
                  <th><span class="text-muted">Detalle</span></th>
                  <th><span class="text-muted">Auditado por</span></th>
                  <th><span class="text-muted">Resuelto por</span></th>
                  <th><span class="text-muted">Acción</span></th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="caso in ajustes" :key="caso.fireId">
                  <!-- 1 Estado resolución -->
                  <td class="text-sm text-wrap">
                    <span class="badge text-uppercase" :class="badgeResolucion(caso.status_resolucion)">
                      {{ caso.status_resolucion }}
                    </span>
                  </td>

                  <!-- 2 ID ajuste -->
                  <td class="text-sm text-wrap">{{ caso.fireIdCorto }}</td>

                  <!-- 3 Fecha carga -->
                  <td class="text-sm text-wrap">{{ caso.fecha_carga }}</td>

                  <!-- 4 Regional -->
                  <td class="text-sm text-wrap">{{ caso.responsable }}</td>

                  <!-- 5 DNI Regional -->
                  <td class="text-sm text-wrap">{{ caso.responsable_dni }}</td>

                  <!-- 6 Operación -->
                  <td class="text-sm text-wrap">{{ caso.operacion_raiz }}</td>

                  <!-- 7 Legajo -->
                  <td class="text-sm text-wrap">{{ caso.legajo }}</td>

                  <!-- 8 Empleado -->
                  <td class="text-sm text-wrap">{{ caso.nombre }}</td>

                  <!-- 9 Concepto -->
                  <td class="text-sm text-wrap">{{ caso.novedad }}</td>

                  <!-- 10 Cantidad -->
                  <td class="text-sm text-wrap">{{ caso.cantidad }}</td>

                  <!-- 11 Detalle -->
                  <td class="text-sm text-wrap">
                    
                    <button class="btn btn-sm btn-info mt-1" @click="verDetalle(caso)">Ver detalle</button>
                  </td>

                  <!-- 12 Auditado por -->
                  <td class="text-sm text-wrap">
                    <span v-if="caso.auditor_nombre && caso.auditor_nombre !== '-'">
                      {{ caso.auditor_nombre }}<br />
                      <small>{{ caso.fecha_auditoria }}</small>
                    </span>
                    <span v-else>-</span>
                  </td>

                  <!-- 13 Resuelto por -->
                  <td class="text-sm text-wrap">
                    <span v-if="caso.resolutor_nombre && caso.resolutor_nombre !== '-'">
                      {{ caso.resolutor_nombre }}<br />
                      <small>{{ caso.fecha_resolucion }}</small>
                    </span>
                    <span v-else>-</span>
                  </td>

                  <!-- 14 Acción -->
                  <td class="text-sm text-wrap">
                    <select
                      v-if="caso.status_resolucion !== 'Resuelto'"
                      class="custom-select mr-3 resolucionSelect"
                      :value="caso.status_resolucion"
                      @change="cambiarResolucion($event, caso)"
                    >
                      <option value="En espera">En espera</option>
                      <option value="Resuelto">Resuelto</option>
                    </select>

                    
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import $ from "jquery";
import Swal from "sweetalert2";
require("datatables.net");
require("datatables.net-buttons/js/buttons.colVis.js")();
require("datatables.net-buttons/js/buttons.html5.js")();
require("datatables.net-buttons/js/buttons.flash.js")();
require("datatables.net-buttons/js/buttons.print.js")();
require("../../../public/assets/css/data-table-estilos-propios.css");

import firebase from "firebase/app";
import "firebase/database";

import ListaCarga from "../ListaCarga";
import moment from "moment";

const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");
const userPermission = JSON.parse(sessionStorage.getItem("userPermisos") || "[]");

export default {
  name: "AjustesResolucionSector",
  components: { ListaCarga },
  data: () => ({
    breadcrumbA: "Inicio",
    breadcrumbB: "Resolución de Ajustes Aprobados",
    descripcion: "Listado de ajustes aprobados por Génesis para resolver y cerrar",
    ajustes: [],
    load: true,
    moduloPermiso: "AjustesResolucion",
  }),
  methods: {
    isEditor(modulo) {
      if (userPermission.find(record => record.ModulosAccess === modulo)) {
        return userPermission.find(record => record.ModulosAccess === modulo).Editor;
      }
      return false;
    },

    addZero(i) {
      return i < 10 ? "0" + i : i;
    },

    timestampActual() {
      const h = new Date();
      const hora = this.addZero(h.getHours());
      const minutos = ("0" + h.getMinutes()).substr(-2);
      const segundos = ("0" + h.getSeconds()).substr(-2);

      const today = new Date();
      const m = today.getMonth() + 1;
      const mes = m < 10 ? "0" + m : m;
      let dia = today.getDate();
      dia = dia < 10 ? "0" + dia : dia;

      return today.getFullYear() + "-" + mes + "-" + dia + " " + hora + ":" + minutos + ":" + segundos;
    },

    usuarioNombre() {
      const nombre = `${userData.leg_nombre || ""} ${userData.leg_apellido || ""}`.trim();
      return nombre || userData.name || "Usuario Génesis";
    },

    usuarioDni() {
      return userData.leg_numdoc || userData.dni || "-";
    },

    usuarioLegajo() {
      return userData.leg_numero || userData.legajo || "-";
    },

    badgeResolucion(status) {
      if (status === "Resuelto") return "badge-success";
      return "badge-warning";
    },

    normalizarStatusResolucion(item) {
      if (item.status_resolucion) return item.status_resolucion;
      if (item.estado_resolucion === "resuelto" || item.cerrado === 1 || item.resuelto === true) return "Resuelto";
      return "En espera";
    },

    esAprobado(item) {
      const status = String(item.status || "").trim().toLowerCase();
      const estado = String(item.estado || "").trim().toLowerCase();
      return status === "aprobado" || estado === "aprobado";
    },

    normalizarAjuste(key, item) {
      const fechaCarga = item.fecha_carga || item.fecha || "-";
      const statusResolucion = this.normalizarStatusResolucion(item);

      return {
        fireId: key,
        fireIdCorto: key.substring(0, 8),
        fecha: item.fecha || fechaCarga,
        fecha_carga: fechaCarga,

        responsable: item.responsable || "-",
        responsable_id: item.responsable_id || "-",
        responsable_dni: item.responsable_dni || "-",

        operacion_id: item.operacion_id || "-",
        operacion_raiz: item.operacion_raiz || "-",

        legajo: item.legajo || "-",
        nombre: item.nombre || "-",

        id_novedad: item.id_novedad || item.bejerman_id || "-",
        bejerman_id: item.bejerman_id || item.id_novedad || "-",
        novedad: item.novedad || item.concepto || "-",
        concepto: item.concepto || item.novedad || "-",
        cantidad: item.cantidad || "-",
        detalle: item.detalle || "-",

        status: item.status || "Aprobado",
        estado: item.estado || "aprobado",

        auditor_nombre: item.auditor_nombre || "-",
        auditor_dni: item.auditor_dni || "-",
        auditor_legajo: item.auditor_legajo || "-",
        fecha_auditoria: item.fecha_auditoria || "-",
        observacion_auditoria: item.observacion_auditoria || "-",

        status_resolucion: statusResolucion,
        estado_resolucion: item.estado_resolucion || (statusResolucion === "Resuelto" ? "resuelto" : "en_espera"),
        cerrado: item.cerrado || (statusResolucion === "Resuelto" ? 1 : 0),
        resuelto: item.resuelto || (statusResolucion === "Resuelto"),
        resolutor_nombre: item.resolutor_nombre || "-",
        resolutor_dni: item.resolutor_dni || "-",
        resolutor_legajo: item.resolutor_legajo || "-",
        fecha_resolucion: item.fecha_resolucion || "-",
        observacion_resolucion: item.observacion_resolucion || "-",
      };
    },

    destruirDataTable() {
      if ($.fn.DataTable && $.fn.DataTable.isDataTable("#ajustes_resolucion")) {
        $("#ajustes_resolucion").DataTable().clear().destroy();
      }
    },

    getAjustes() {
      this.load = true;
      this.ajustes = [];
      this.destruirDataTable();

      firebase.database().ref("ajustes_novedades").once("value")
        .then((snapshot) => {
          const data = [];

          snapshot.forEach((child) => {
            const item = child.val() || {};
            if (this.esAprobado(item)) {
              data.push(this.normalizarAjuste(child.key, item));
            }
          });

          data.sort((a, b) => {
            const fa = a.fecha_carga || "";
            const fb = b.fecha_carga || "";
            return fb.localeCompare(fa);
          });

          this.ajustes = data;
          this.load = false;

          this.$nextTick(() => {
            this.initDataTable();
          });
        })
        .catch((error) => {
          console.error("Error al obtener ajustes aprobados:", error);
          this.load = false;
          Swal.fire(
            "Error",
            "Ocurrió un error al cargar los ajustes aprobados. Revise la conexión o Firebase.",
            "error"
          );
        });
    },

    initDataTable() {
      this.destruirDataTable();

      const table = $("#ajustes_resolucion").DataTable({
        language: {
          decimal: ",",
          thousands: ".",
          info: "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
          infoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
          infoFiltered: "(filtrado de un total de _MAX_ registros)",
          loadingRecords: "Cargando...",
          lengthMenu: "Mostrar _MENU_ registros",
          paginate: {
            first: "Primero",
            last: "Último",
            next: "Siguiente",
            previous: "Anterior"
          },
          processing: "Procesando...",
          search: "Buscar:",
          searchPlaceholder: "Término de búsqueda",
          zeroRecords: "No se encontraron resultados",
          emptyTable: "Ningún dato disponible en esta tabla",
          aria: {
            sortAscending: ": Activar para ordenar la columna de manera ascendente",
            sortDescending: ": Activar para ordenar la columna de manera descendente"
          },
        },
        scrollX: false,
        autoWidth: false,
        search: { regex: true },
        dom: "Bfrtip",
        responsive: false,
        nowrap: false,
        order: [[2, "desc"]],
        columns: [
          { width: "95px" },
          { width: "95px" },
          { width: "145px" },
          { width: "150px" },
          { width: "115px" },
          { width: "150px" },
          { width: "85px" },
          { width: "190px" },
          { width: "150px" },
          { width: "90px" },
          { width: "170px", orderable: false },
          { width: "145px" },
          { width: "145px" },
          { width: "145px", orderable: false }
        ],
        columnDefs: [
          { targets: "_all", className: "ajuste-celda" }
        ],
        drawCallback: function() {
          if ($.fn.DataTable && $.fn.DataTable.isDataTable("#ajustes_resolucion")) {
            $("#ajustes_resolucion").DataTable().columns.adjust();
          }
        },
        buttons: [
          "copy",
          "excel",
          "csv",
          {
            text: "En espera",
            className: "btn btn-warning",
            action: function() {
              table.columns(0).search("En espera").draw();
            }
          },
          {
            text: "Resuelto",
            className: "btn btn-success",
            action: function() {
              table.columns(0).search("Resuelto").draw();
            }
          },
          {
            text: "Todos",
            className: "btn btn-secondary",
            action: function() {
              table.columns(0).search("").draw();
              table.columns(2).search("").draw();
            }
          }
        ]
      });

      const diasEntreFechas = (desde, hasta) => {
        const diaActual = moment(desde);
        const fechas = [];
        while (diaActual.isSameOrBefore(hasta)) {
          fechas.push(diaActual.format("YYYY-MM-DD"));
          diaActual.add(1, "days");
        }
        return fechas;
      };

      $("#buscar").off("click").on("click", function() {
        const desdeVal = $("#desde").val();
        const hastaVal = $("#hasta").val();

        if (!desdeVal || !hastaVal) {
          Swal.fire("Atención", "Seleccione fecha desde y fecha hasta.", "warning");
          return;
        }

        const desde = moment(desdeVal);
        const hasta = moment(hastaVal);

        if (!desde.isValid() || !hasta.isValid() || desde.isAfter(hasta)) {
          Swal.fire("Atención", "El rango de fechas no es válido.", "warning");
          return;
        }

        const results = diasEntreFechas(desde, hasta);
        const filtro = results.join("|");
        table.column(2).search(filtro, true, false).draw();
      });
    },

    cambiarResolucion(event, caso) {
      const nuevoStatus = event.target.value;
      const statusAnterior = caso.status_resolucion;

      if (!nuevoStatus || nuevoStatus === statusAnterior) return;

      if (statusAnterior === "Resuelto") {
        event.target.value = statusAnterior;
        Swal.fire("Caso cerrado", "Este ajuste ya fue resuelto y no puede volver a modificarse.", "info");
        return;
      }

      if (nuevoStatus === "En espera") {
        event.target.value = statusAnterior;
        return;
      }

      if (nuevoStatus === "Resuelto") {
        Swal.fire({
          title: "¿Marcar ajuste como resuelto?",
          text: `Se cerrará definitivamente el ajuste de ${caso.nombre} por ${caso.novedad}.`,
          input: "textarea",
          inputPlaceholder: "Observación opcional de resolución",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#28a745",
          cancelButtonColor: "#6c757d",
          confirmButtonText: "Sí, resolver y cerrar",
          cancelButtonText: "Cancelar"
        }).then((result) => {
          if (result.isConfirmed) {
            this.resolverAjuste(caso, result.value ? result.value.trim() : "-");
          } else {
            event.target.value = statusAnterior;
          }
        });
      }
    },

    resolverAjuste(caso, observacion) {
      const timestamp = this.timestampActual();
      const resolutor = this.usuarioNombre();

      Swal.fire({
        title: "Actualizando...",
        text: "Por favor espere mientras se cierra el ajuste.",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const updateData = {
        // Se mantiene la aprobación de Génesis. No se pisa status ni estado.
        status: "Aprobado",
        estado: "aprobado",

        status_resolucion: "Resuelto",
        estado_resolucion: "resuelto",
        cerrado: 1,
        resuelto: true,
        fecha_resolucion: timestamp,
        resolutor_nombre: resolutor,
        resolutor_dni: this.usuarioDni(),
        resolutor_legajo: this.usuarioLegajo(),
        observacion_resolucion: observacion || "-"
      };

      const historialData = {
        fecha: timestamp,
        accion: "Resolución de ajuste",
        status_auditoria: caso.status,
        estado_auditoria: caso.estado,
        status_resolucion_anterior: caso.status_resolucion,
        status_resolucion_nuevo: "Resuelto",
        estado_resolucion: "resuelto",
        observacion: observacion || "-",
        nombre: resolutor,
        dni: this.usuarioDni(),
        legajo: this.usuarioLegajo()
      };

      const ref = firebase.database().ref("ajustes_novedades/" + caso.fireId);

      ref.update(updateData)
        .then(() => ref.child("historial").push(historialData))
        .then(() => {
          Swal.fire({
            icon: "success",
            title: "Caso cerrado",
            text: "El ajuste quedó resuelto correctamente.",
            timer: 1800,
            showConfirmButton: false
          });
          this.getAjustes();
        })
        .catch((error) => {
          console.error("Error al resolver ajuste:", error);
          Swal.fire(
            "Error",
            "No se pudo resolver el ajuste. Revise la conexión e intente nuevamente.",
            "error"
          );
          this.getAjustes();
        });
    },

    escapeHtml(value) {
      return String(value || "-")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/\"/g, "&quot;")
        .replace(/'/g, "&#039;");
    },

    resumenDetalle(detalle) {
      const value = String(detalle || "-").trim();
      if (!value || value === "-") return "-";
      return value.length > 45 ? value.substring(0, 45) + "..." : value;
    },

    verDetalle(caso) {
      Swal.fire({
        title: "Detalle del ajuste aprobado",
        width: 850,
        html: `
          <div style="text-align:left; font-size:14px;">
            <b>ID Firebase:</b> ${this.escapeHtml(caso.fireId)}<br>
            <b>Fecha carga:</b> ${this.escapeHtml(caso.fecha_carga)}<br>
            <b>Regional:</b> ${this.escapeHtml(caso.responsable)} (${this.escapeHtml(caso.responsable_dni)})<br>
            <b>Operación:</b> ${this.escapeHtml(caso.operacion_raiz)}<br>
            <hr>
            <b>Legajo:</b> ${this.escapeHtml(caso.legajo)}<br>
            <b>Empleado:</b> ${this.escapeHtml(caso.nombre)}<br>
            <b>Concepto:</b> ${this.escapeHtml(caso.novedad)}<br>
            <b>ID concepto / Bejerman:</b> ${this.escapeHtml(caso.bejerman_id)}<br>
            <b>Cantidad:</b> ${this.escapeHtml(caso.cantidad)}<br>
            <b>Detalle:</b><br>${this.escapeHtml(caso.detalle)}<br>
            <hr>
            <b>Auditoría Génesis:</b> ${this.escapeHtml(caso.status)}<br>
            <b>Auditado por:</b> ${this.escapeHtml(caso.auditor_nombre)}<br>
            <b>DNI auditor:</b> ${this.escapeHtml(caso.auditor_dni)}<br>
            <b>Fecha auditoría:</b> ${this.escapeHtml(caso.fecha_auditoria)}<br>
            <b>Observación auditoría:</b><br>${this.escapeHtml(caso.observacion_auditoria)}<br>
            <hr>
            <b>Estado resolución:</b> ${this.escapeHtml(caso.status_resolucion)}<br>
            <b>Resuelto por:</b> ${this.escapeHtml(caso.resolutor_nombre)}<br>
            <b>DNI resolutor:</b> ${this.escapeHtml(caso.resolutor_dni)}<br>
            <b>Fecha resolución:</b> ${this.escapeHtml(caso.fecha_resolucion)}<br>
            <b>Observación resolución:</b><br>${this.escapeHtml(caso.observacion_resolucion)}
          </div>
        `,
        confirmButtonText: "Cerrar"
      });
    }
  },

  mounted() {
    this.getAjustes();
  }
};
</script>

<style type="text/css">
.imprimir {
  color: #212529 !important;
  background-color: #fbbc06 !important;
  border-color: #fbbc06 !important;
}

#ajustes_resolucion {
  width: 100% !important;
  table-layout: fixed !important;
}

#ajustes_resolucion th,
#ajustes_resolucion td {
  box-sizing: border-box;
  vertical-align: middle !important;
  white-space: normal !important;
  overflow-wrap: anywhere;
  word-break: break-word;
  padding: 8px 10px !important;
}

#ajustes_resolucion th span {
  display: block;
  line-height: 1.15;
}

#ajustes_resolucion .badge {
  white-space: nowrap;
}

#ajustes_resolucion .custom-select {
  min-width: 125px;
  max-width: 100%;
}

#ajustes_resolucion .btn {
  white-space: nowrap;
}

.table-responsive {
  overflow-x: auto;
}
</style>